/** PIP strip (DESIGN-client §7): "Your turn · 7s" / "Bidding" / "120 – 85" over the tiny trick view. */
import { useEffect, useState } from 'react';
import { useStore } from '../../store/store';

export function pipText(opts: { phase: string; turn: number; seat: number | null; endsAt: number; now: number; scores: [number, number] }): string {
  const { phase, turn, seat, endsAt, now, scores } = opts;
  const secs = endsAt > 0 ? Math.max(0, Math.ceil((endsAt - now) / 1000)) : null;
  if (phase === 'bidding') return secs != null ? `Bidding · ${secs}s` : 'Bidding';
  if (phase === 'playing' && seat != null && turn === seat) return secs != null ? `Your turn · ${secs}s` : 'Your turn';
  return `${scores[0]} – ${scores[1]}`;
}

export function PipView() {
  const table = useStore((s) => s.table);
  const seat = useStore((s) => s.session.seat);
  const displayed = useStore((s) => s.presentation.displayedScores);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const iv = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(iv);
  }, []);
  const text = pipText({
    phase: table?.phase ?? 'lobby',
    turn: table?.turn ?? -1,
    seat,
    endsAt: table?.timer.endsAt ?? 0,
    now,
    scores: [table?.teams[0]?.score ?? displayed[0], table?.teams[1]?.score ?? displayed[1]],
  });
  return (
    <div className="pip-strip" data-testid="pip-strip">
      <span>{text}</span>
      <span className="muted">♠</span>
    </div>
  );
}
